'use client'

import { ButtonArrow } from '@/components/ui/button-arrow'
import { useLingui } from '@lingui/react'
import { motion } from 'framer-motion'
import Image from 'next/image'
import React from 'react'
import { NumberTicker } from '../../fragments/number-ticket'

const AboutSection: React.FC = () => {
  const { i18n } = useLingui()

  return (
    <section className='flex items-center bg-white min-h-svh padding-section'>
      <div className='container flex gap-8 mx-auto max-md:flex-col'>
        {/* Left Column - Text Content */}
        <motion.div
          className='relative px-0 md:w-2/3'
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Background Image or Illustration */}
          <Image
            src='/landing/home/pione-illustration.png'
            alt='PIONE Group Illustration'
            width={760}
            height={720}
            loading='lazy'
            className='object-cover ml-auto md:ml-[7dvw] pt-[5vh] max-sm:pt-[28vh]'
          />
          <motion.div
            className='absolute top-0 left-0 z-10 space-y-7'
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <h2 className='bg-text-gradient w-fit'>{i18n._(`ABOUT PIONE GLOBAL`)}</h2>
            <p className='max-w-3xl text-xl font-semibold leading-relaxed sm:text-3xl lg:text-4xl font-jost text-custom'>
              {i18n._(
                `Pione Global is a pioneer in developing technology solutions that integrate Blockchain, AI, and IoT into real-world applications.`
              )}
            </p>
            <ButtonArrow showSvg className='font-normal'>
              {i18n._(`Discover more`)}
            </ButtonArrow>
          </motion.div>
        </motion.div>

        {/* Info Boxes */}
        <div className='relative z-10 flex gap-10 mt-4 max-sm:flex-col md:flex-col md:w-1/3 text-custom'>
          {/* Years of Expertise */}
          <motion.div
            className='text-left max-md:w-full'
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className='text-6xl font-bold text-accent-blue'>
              <NumberTicker value={12} />+
            </div>
            <p className='pt-2 text-2xl font-semibold font-jost'>{i18n._(`Years of Expertise`)}</p>
            <p className='pt-4 font-light'>
              {i18n._(
                `With a young, enthusiastic, and creative team, along with experts with more than 12 years of experience in the Blockchain field, PIONE GLOBAL is confident in bringing Vietnam's outstanding services and products to the world.`
              )}
            </p>
          </motion.div>

          {/* Prestigious Awards */}
          <motion.div
            className='text-left max-md:w-full'
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className='text-6xl font-bold text-accent-orange'>
              <NumberTicker value={10} />+
            </div>
            <p className='pt-2 text-2xl font-semibold font-jost'>{i18n._(`Prestigious Award`)}</p>
            <ul className='pt-4 font-light'>
              <li>{i18n._(`Top 10 Leading Brands in Asia-Pacific 2020`)}</li>
              <li>{i18n._(`Top 30 Leading Brands in Vietnam 2020`)}</li>
              <li>{i18n._(`Top 10 Leading Brands in Vietnam 2021`)}</li>
              <li>{i18n._(`Top 10 Blockchain Technology Companies in Vietnam`)}</li>
              <li>{i18n._(`Top 5 Strong Brands in Asia`)}</li>
              <li>{i18n._(`Top 5 Outstanding Brands in Asia-Pacific`)}</li>
              <li>{i18n._(`Top 10 Trusted Brands in Asia`)}</li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
export default AboutSection
